import * as React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { FormControlLabel, Switch, Tooltip, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Zoom, Typography, Box, Button, FormControl, Select } from '@material-ui/core';
import { ArrowUpward, ArrowDownward, Reorder } from '@material-ui/icons';
import { EditMatchResultSetPoints } from './EditMatchResultSetPoints';
import { SelectPlayerPopup } from '../players/selectPlayerPopup';
import { LeagueIndividualMatchViewModel, LeagueMatchPlayerViewModel, PlayerViewModel, LeagueMatchSet } from "../../api/api";
import { AbilityContext, AbilitySubjects } from '../../common/users';
import { DisciplineCategory, Disciplines, DisciplineGender } from '../../common/matches/disciplines';
import { PlayerHelper, genderMale, genderFemale } from '../../common/players/playerHelper';
const useStyles = makeStyles({
    playerTable: {
        maxWidth: 750,
        '& .MuiTableCell-head': {
            '&.MuiTableCell-sizeSmall': {
                fontWeight: 'bold',
                textAlign: 'center',
                borderBottom: '2px solid #000',
                borderTop: '2px solid #000'
            }
        },
        '& .MuiTableCell-sizeSmall': {
            padding: 0,
            paddingLeft: 5,
            paddingRight: 5,
            border: '1px solid #aaa',
            '&.points': {
                paddingLeft: 2,
                paddingRight: 2
            }
        }
    },
    goldenSetSelect: {
        maxWidth: 30,
    },
});
const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#eee',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);
export const EditMatchResultPlayersSelect = props => {
    const match = props.match.match;
    const teamMatches = props.match.combinedTeamMatches;
    const classes = useStyles();
    const ability = React.useContext(AbilityContext);
    const [open, setOpen] = React.useState(false);
    const [selectedTeam, setSelectedTeam] = React.useState(props.match.team1Players);
    const [canChoosePlayers, setCanChoosePlayers] = React.useState(true);
    const [nonSelectablePlayers, setNonSelectablePlayers] = React.useState([{ playerId: 0, reason: '' }]);
    const emptySelectedPlayer = { playerId: 0, matchIndex: -1, matchId: 0, disciplineCode: '', teamId: 0, matchPlayerIndex: 0 };
    const [selectedPlayer, setSelectedPlayer] = React.useState(emptySelectedPlayer);
    const [autoSortPlayers, setAutoSortPlayers] = React.useState(match.matchResultAutosortPlayersEnabled);
    const noOfTeams = 2;
    const team1Players = props.match.team1Players.reduce((map, obj) => {
        map[obj.playerID] = obj;
        return map;
    }, {});
    const team2Players = props.match.team2Players.reduce((map, obj) => {
        map[obj.playerID] = obj;
        return map;
    }, {});
    const setsHeader = [];
    if (props.showEditPoints) {
        for (let i = 0; i < match.maxSets; i++) {
            setsHeader.push(React.createElement(TableCell, { key: i }, i + 1));
        }
        setsHeader.push(React.createElement(TableCell, { className: "wo" },
            "Vinder W.O.",
            React.createElement("br", null),
            React.createElement(HtmlTooltip, { TransitionComponent: Zoom, title: React.createElement(React.Fragment, null,
                    React.createElement(Typography, { color: "inherit" }, "Indtast cifrene p\u00E5 det tidspunkt hvor kampen blev afbrudt, og v\u00E6lg det hold som har vundet kampen")) },
                React.createElement("a", { href: "#" }, "Hj\u00E6lp"))));
    }
    const handleAutoSortingSwitchChange = (event) => {
        setAutoSortPlayers(event.target.checked);
    };
    const getTeamMatchAndPlayers = (matchIndex, teamId) => {
        const teamMatch = teamMatches.find(m => m.matchIndex === matchIndex);
        const computedMatch = individualMatches.find(m => m.matchIndex === matchIndex);
        return { teamMatch: teamMatch, teamPlayers: teamId && teamMatch.teamPlayers ? teamMatch.teamPlayers[teamId] : undefined, computedMatch: computedMatch };
    };
    const handleClickOpen = (individualMatch, teamPlayer, teamIndex, teamId, matchPlayerIndex) => {
        setCanChoosePlayers(teamPlayer.selectPlayerType !== 1);
        let players = teamIndex === 0 ? props.match.team1Players : props.match.team2Players;
        const disciplineGender = Disciplines.getDisciplineGenderFromCode(individualMatch.disciplineCode);
        const disciplineCategory = Disciplines.getDisciplineCategoryFromCode(individualMatch.disciplineCode);
        if (disciplineGender === DisciplineGender.Men)
            players = players.filter((player) => player.gender === genderMale);
        else if (disciplineGender === DisciplineGender.Women)
            players = players.filter((player) => player.gender === genderFemale);
        else if (disciplineGender === DisciplineGender.Mixed && teamPlayer.playerGender)
            players = players.filter((player) => player.gender === teamPlayer.playerGender);
        if (disciplineCategory !== DisciplineCategory.Single) {
            const { teamPlayers } = getTeamMatchAndPlayers(individualMatch.matchIndex, teamId);
            if (teamPlayers && teamPlayers.length > 1) {
                const teamMatePlayer = teamPlayers.find((p) => p.playerId !== teamPlayer.playerId);
                setNonSelectablePlayers([{ playerId: teamPlayer.playerId, reason: '' }]);
                if (teamMatePlayer) {
                    players = players.filter((player) => player.playerID !== teamMatePlayer.playerId);
                }
            }
        }
        setSelectedTeam(players);
        setSelectedPlayer({ playerId: teamPlayer.playerId, matchIndex: individualMatch.matchIndex, matchId: individualMatch.matchId, disciplineCode: individualMatch.disciplineCode, teamId: teamId, matchPlayerIndex: matchPlayerIndex });
        setOpen(true);
    };
    const getPlayersPointsFromDiscipline = (player, disciplineCode) => {
        const disciplineCategory = typeof disciplineCode === "string" ? Disciplines.getDisciplineCategoryFromCode(disciplineCode) : disciplineCode;
        let playerSeasonPoints = 0;
        switch (disciplineCategory) {
            case DisciplineCategory.Double:
                playerSeasonPoints = player.doublePoints;
                break;
            case DisciplineCategory.Mixed:
                playerSeasonPoints = player.mixPoints;
                break;
            case DisciplineCategory.Single:
                playerSeasonPoints = player.singlePoints;
                break;
        }
        return playerSeasonPoints;
    };
    const selectedPlayerFromChildren = (player) => {
        let { teamMatch, teamPlayers, computedMatch } = getTeamMatchAndPlayers(selectedPlayer.matchIndex, selectedPlayer.teamId);
        const computedTeam = computedMatch.teams.find(team => team.teamId === selectedPlayer.teamId);
        const disciplineGender = Disciplines.getDisciplineGenderFromCode(selectedPlayer.disciplineCode);
        if (disciplineGender === DisciplineGender.Men && player.gender === genderFemale) {
            computedTeam.showWarning = player.name + " kan ikke vælges til en herrekamp.";
            setOpen(false);
            return;
        }
        else if (disciplineGender == DisciplineGender.Women && player.gender === genderMale) {
            computedTeam.showWarning = player.name + " kan ikke vælges til en damekamp.";
            setOpen(false);
            return;
        }
        const disciplineCategory = Disciplines.getDisciplineCategoryFromCode(selectedPlayer.disciplineCode);
        const playerSeasonPoints = getPlayersPointsFromDiscipline(player, disciplineCategory);
        const createNewPlayer = () => {
            return new LeagueMatchPlayerViewModel({ playerId: player.playerID, player: new PlayerViewModel({ name: player.name, playerNumber: player.playerNumber }) });
        };
        // Means no players were returned for this team from the backend
        if (!teamPlayers) {
            teamMatch.teamPlayers = Object.assign({}, Object.assign(Object.assign({}, teamMatch.teamPlayers), { [selectedPlayer.teamId]: [] }));
            teamPlayers = teamMatch.teamPlayers[selectedPlayer.teamId];
            teamPlayers.push(new LeagueMatchPlayerViewModel());
            if (disciplineCategory !== DisciplineCategory.Single)
                teamPlayers.push(new LeagueMatchPlayerViewModel());
        }
        let selectedPlayerToReplace = teamPlayers.find((p) => p.playerId === selectedPlayer.playerId);
        if (!selectedPlayerToReplace) {
            teamPlayers[selectedPlayer.matchPlayerIndex] = selectedPlayerToReplace = createNewPlayer();
        }
        selectedPlayerToReplace.playerId = player.playerID;
        selectedPlayerToReplace.player.name = player.name;
        selectedPlayerToReplace.player.playerNumber = player.playerNumber;
        selectedPlayerToReplace.player.disciplinePoints = playerSeasonPoints;
        selectedPlayerToReplace.player.gender = player.gender;
        let computedPlayer = computedTeam.players.find(player => player.playerId === selectedPlayer.playerId);
        if (!computedPlayer) {
            computedTeam[selectedPlayer.matchPlayerIndex] = computedPlayer = { playerId: player.playerID, playerName: player.name, playerGender: player.gender, playerNumber: player.playerNumber, points: playerSeasonPoints, selectPlayerType: 0 };
        }
        computedPlayer.playerId = player.playerID;
        computedPlayer.playerName = player.name;
        computedPlayer.playerNumber = player.playerNumber;
        computedPlayer.points = playerSeasonPoints;
        computedPlayer.playerGender = player.gender;
        let teamPoints = 0;
        computedTeam.players.map(player => teamPoints += player.points || 0);
        computedTeam.points = teamPoints;
        // Update state for individual match
        props.updateIndividualMatchState(teamMatch);
        const matches = generateComputedMatchData();
        updateMatches(matches);
        setOpen(false);
    };
    const onSetPointsChange = (team1Points, team2Points, individualMatchId, matchIndex, setIndex) => {
        //const { teamMatch } = getTeamMatchAndPlayers(individualMatchId, matchIndex);
        const { teamMatch } = getTeamMatchAndPlayers(matchIndex);
        let matchSet = teamMatch.leagueMatchSet.find((set) => set.setIndex === setIndex);
        if (!matchSet) {
            matchSet = new LeagueMatchSet({ leagueMatchIndividualMatchId: individualMatchId, points1: team1Points, points2: team2Points, setIndex: setIndex, teamIndex1: 0, teamIndex2: 1 });
            teamMatch.leagueMatchSet.push(matchSet);
        }
        else {
            matchSet.points1 = team1Points;
            matchSet.points2 = team2Points;
        }
        props.updateIndividualMatchState(teamMatch);
    };
    const onSetWalkover = (walkOverTeamIndex, individualMatchId) => {
        //const { teamMatch } = getTeamMatchAndPlayers(individualMatchId);
        const teamMatch = teamMatches.find(teamMatch => teamMatch.leagueMatchIndividualMatchId === individualMatchId);
        teamMatch.winnerWo = walkOverTeamIndex === "" ? undefined : Number(walkOverTeamIndex);
        props.updateIndividualMatchState(teamMatch);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const shortTeamName = (teamIndex) => {
        let shortName1 = match.teamName1.substring(0, 1), shortName2 = match.teamName2.substring(0, 1);
        if (shortName1 === shortName2)
            return teamIndex === 0 ? "1" : "2";
        else
            return teamIndex === 0 ? shortName1 : shortName2;
    };
    const generateComputedMatchData = () => {
        let generatedMissingPlayerId = -1;
        const individualMatchesInDiscipline = [];
        const computedMatchRows = [];
        for (let teamMatch of teamMatches) {
            teamMatch = teamMatch || new LeagueIndividualMatchViewModel({ leagueMatchIndividualMatchId: 0, matchIndex: 0, disciplineCode: '', disciplineRanking: 0 });
            teamMatch.isNotInValidPointOrder = false;
            const disciplineCode = Disciplines.getShortName(teamMatch.disciplineCode) || teamMatch.disciplineCode;
            const disciplineCategory = Disciplines.getDisciplineCategoryFromCode(disciplineCode);
            const disciplineGender = Disciplines.getDisciplineGenderFromCode(disciplineCode);
            let computedMatchRow = {
                matchIndex: teamMatch.matchIndex,
                matchId: teamMatch.leagueMatchIndividualMatchId,
                disciplineCode: disciplineCode,
                disciplineRanking: teamMatch.disciplineRanking,
                winnerWalkOver: teamMatch.winnerWo,
                setPoints: [],
                teams: [],
                isDoubleMatch: false,
                isGoldenSet: teamMatch.isGoldenSet
            };
            [...Array(noOfTeams)].map((obj, teamIndex) => {
                const strIndex = teamIndex + 1;
                const teamId = match["leagueGroupTeamId" + strIndex];
                computedMatchRow.teams.push({ teamIndex: teamIndex, teamId: teamId, name: match["teamName" + strIndex], shortName: shortTeamName(teamIndex), players: [], points: 0 });
                let matchPlayers = teamMatch.teamPlayers && teamMatch.teamPlayers[teamId];
                // If no players were assigned to the team
                if (!matchPlayers) {
                    matchPlayers = [new LeagueMatchPlayerViewModel()];
                }
                if (matchPlayers.length === 1 && disciplineCategory !== DisciplineCategory.Single) {
                    matchPlayers.push(new LeagueMatchPlayerViewModel());
                }
                let combinedPlayerPoints;
                matchPlayers && matchPlayers.length > 0 && matchPlayers.map((matchPlayer, index) => {
                    let playerId, playerPoints, playerNumber, playerName, playerGender, selectPlayerType = teamMatch.selectPlayerType;
                    if (matchPlayer && matchPlayer.player) {
                        playerId = matchPlayer.playerId;
                        playerNumber = matchPlayer.player.playerNumber;
                        playerName = matchPlayer.player.name;
                        playerGender = matchPlayer.player.gender;
                        if (matchPlayer.noShow) {
                            playerName = "Ikke fremmødt";
                            playerId = -2;
                        }
                        else if (matchPlayer.unknown) {
                            playerName = "Ukendt spiller";
                            playerId = -1;
                        }
                        const teamPlayer = teamIndex === 0 ? team1Players[playerId] : team2Players[playerId];
                        const isDoubleMatch = disciplineCategory !== DisciplineCategory.Single;
                        if (teamPlayer) {
                            const points = getPlayersPointsFromDiscipline(teamPlayer, disciplineCode);
                            if (points) {
                                playerPoints = points;
                                combinedPlayerPoints = isDoubleMatch ? playerPoints + (combinedPlayerPoints || 0) : undefined;
                            }
                            else {
                                playerPoints = undefined;
                            }
                            computedMatchRow.isDoubleMatch = isDoubleMatch;
                        }
                        // Not in team, probably new selected player from search or something similar
                        else if (matchPlayer.player.disciplinePoints) {
                            playerPoints = matchPlayer.player.disciplinePoints;
                            if (isDoubleMatch) {
                                combinedPlayerPoints = playerPoints + (combinedPlayerPoints || 0);
                            }
                        }
                    }
                    else {
                        playerId = (generatedMissingPlayerId -= 10);
                        playerGender = PlayerHelper.getPlayerGenderFromDisciplineGender(disciplineGender, index);
                    }
                    if ((computedMatchRow.isDoubleMatch && computedMatchRow.teams[teamIndex].players.length < 2) ||
                        (!computedMatchRow.isDoubleMatch && computedMatchRow.teams[teamIndex].players.length < 1)) {
                        computedMatchRow.teams[teamIndex].players.push({
                            playerId: playerId,
                            playerNumber: playerNumber,
                            playerName: playerName,
                            playerGender: playerGender,
                            selectPlayerType: selectPlayerType,
                            points: playerPoints
                        });
                    }
                    let teamPoints = 0;
                    computedMatchRow.teams[teamIndex].players.map(player => teamPoints += player.points || 0);
                    computedMatchRow.teams[teamIndex].points = teamPoints;
                });
            });
            props.showEditPoints && [...Array(match.maxSets)].map((obj, setIndex) => {
                let points1, points2, matchSet;
                // Scroll forward to teamMatch.leagueMatchSet.setIndex === setIndex
                if (teamMatch.leagueMatchSet) {
                    matchSet = teamMatch.leagueMatchSet.find((set) => set && set.setIndex === setIndex);
                    if (matchSet) {
                        points1 = matchSet.points1;
                        points2 = matchSet.points2;
                    }
                }
                computedMatchRow.setPoints.push({ points1: points1, points2: points2 });
            });
            computedMatchRows.push(computedMatchRow);
            if (autoSortPlayers) {
                if (!individualMatchesInDiscipline[disciplineCode])
                    individualMatchesInDiscipline[disciplineCode] = [];
                individualMatchesInDiscipline[disciplineCode].push(computedMatchRow);
                findAndMarkOutOfOrderMatches(individualMatchesInDiscipline[disciplineCode], computedMatchRows);
            }
        }
        return computedMatchRows;
    };
    const findAndMarkOutOfOrderMatches = (individualMatchesInDiscipline, allMatches) => {
        const curIndex = individualMatchesInDiscipline.length - 1;
        const curMatch = individualMatchesInDiscipline[curIndex];
        let prevMatch = individualMatchesInDiscipline[curIndex - 1];
        for (let i = 0, j = curMatch.teams.length; i < j; i++) {
            let prevPoints = prevMatch && prevMatch.teams[i].points;
            const curPoints = curMatch.teams[i].points;
            // If match above should be moved up, see if we need to move this up as well, by rewinding to the match marked as 'down'
            if (prevMatch && prevMatch.teams[i].moveDirectionToBeValid === 'up') {
                for (let m = curIndex - 1, k = 0; m >= k; m--) {
                    const rewindedMatch = individualMatchesInDiscipline[m];
                    if (rewindedMatch && rewindedMatch.teams[i].moveDirectionToBeValid === 'down') {
                        prevMatch = rewindedMatch;
                        prevPoints = prevMatch && prevMatch.teams[i].points;
                        break;
                    }
                }
            }
            if (prevPoints && curPoints && (prevPoints !== -1 && curPoints !== -1) && curPoints > prevPoints) {
                const cur = allMatches.find(match => match.matchId === curMatch.matchId && match.teams[i].teamId === curMatch.teams[i].teamId);
                const prev = allMatches.find(match => match.matchId === prevMatch.matchId && match.teams[i].teamId === prevMatch.teams[i].teamId);
                //if (curMatch.teams[i].moveDirectionToBeValid === undefined || prevMatch.teams[i].moveDirectionToBeValid === undefined) {
                if (!curMatch.teams[i].moveDirectionToBeValid || !prevMatch.teams[i].moveDirectionToBeValid) {
                    cur.teams[i].moveDirectionToBeValid = curMatch.teams[i].moveDirectionToBeValid = 'up';
                    prev.teams[i].moveDirectionToBeValid = prevMatch.teams[i].moveDirectionToBeValid = 'down';
                    // update state match data
                    const curStateMatch = teamMatches.find(teamMatch => teamMatch.leagueMatchIndividualMatchId === cur.matchId);
                    curStateMatch.isNotInValidPointOrder = true;
                    const prevStateMatch = teamMatches.find(teamMatch => teamMatch.leagueMatchIndividualMatchId === prev.matchId);
                    prevStateMatch.isNotInValidPointOrder = true;
                }
            }
        }
        return allMatches;
    };
    const autoSort = () => {
        let newMatches = [...individualMatches];
        const errorMatches = newMatches.filter(match => match.teams.filter(team => team.moveDirectionToBeValid !== undefined && team.moveDirectionToBeValid !== '').length > 0);
        const sortedErrorMatches = JSON.parse(JSON.stringify(errorMatches));
        sortedErrorMatches.sort((matchA, matchB) => {
            let compare = 0;
            for (let teamIndex = 0; teamIndex < 2; teamIndex++) {
                if (!matchA.teams[teamIndex].moveDirectionToBeValid || !matchB.teams[teamIndex].moveDirectionToBeValid)
                    continue;
                return matchB.teams[teamIndex].points - matchA.teams[teamIndex].points;
            }
            return compare;
        });
        for (let matchIndex = 0; matchIndex < errorMatches.length; matchIndex++) {
            for (let teamIndex = 0; teamIndex < 2; teamIndex++) {
                if (!errorMatches[matchIndex].teams[teamIndex].moveDirectionToBeValid)
                    continue;
                if (props.disablePlayerEditForTeamIndex !== undefined) {
                    if (props.disablePlayerEditForTeamIndex !== teamIndex)
                        continue;
                }
                errorMatches[matchIndex].teams[teamIndex] = sortedErrorMatches[matchIndex].teams[teamIndex];
                errorMatches[matchIndex].teams[teamIndex].moveDirectionToBeValid = undefined;
            }
        }
        updateMatches(newMatches);
    };
    const canEdit = ability.can("edit", AbilitySubjects.LeagueMatchResults);
    const extraInputProps = {
        disabled: true
    };
    if (canEdit)
        extraInputProps.disabled = false;
    const initialState = generateComputedMatchData();
    const [individualMatches, setIndividualMatches] = React.useState(initialState);
    const updateMatches = (matches) => {
        setIndividualMatches(matches);
        for (const match of matches) {
            const teamMatch = teamMatches.find(teamMatch => teamMatch.matchIndex === match.matchIndex);
            teamMatch.isNotInValidPointOrder = match.teams.find(team => team.moveDirectionToBeValid && team.moveDirectionToBeValid !== '') !== undefined;
            teamMatch.disciplineCode = match.disciplineCode;
            match.teams.map(team => {
                const computedPlayers = match.teams[team.teamIndex].players;
                if (teamMatch.teamPlayers) {
                    teamMatch.teamPlayers[team.teamId] = [];
                    let playerIndex = 0;
                    for (const computedPlayer of computedPlayers) {
                        teamMatch.teamPlayers[team.teamId].push(new LeagueMatchPlayerViewModel({
                            playerId: computedPlayer.playerId,
                            playerIndex: playerIndex++,
                            player: new PlayerViewModel({
                                gender: computedPlayer.playerGender,
                                name: computedPlayer.playerName,
                                playerNumber: computedPlayer.playerNumber,
                                disciplinePoints: computedPlayer.points
                            })
                        }));
                    }
                }
            });
        }
    };
    const buildTeamCells = (individualMatch) => {
        return individualMatch.teams.map((team, teamIndex) => {
            const td = (React.createElement(TableCell, { key: individualMatch.matchId + "-" + teamIndex, style: team.moveDirectionToBeValid ? { backgroundColor: 'red' } : (team.showWarning ? { backgroundColor: 'yellow' } : {}) },
                React.createElement("div", { className: "teamhdr" }),
                React.createElement("div", null, team.players.map((teamPlayer, playerIndex) => {
                    let playerLinkProps = {
                        style: {
                            //borderTop: (index > 0) ? '1px dashed #aaaaaa' : 'none',
                            fontSize: 10, cursor: 'pointer'
                        },
                        onClick: null
                    };
                    if (canEdit && individualMatch.disciplineCode) {
                        if (props.disablePlayerEditForTeamIndex !== undefined) {
                            if (props.disablePlayerEditForTeamIndex == teamIndex)
                                playerLinkProps.onClick = () => handleClickOpen(individualMatch, teamPlayer, teamIndex, team.teamId, playerIndex);
                            else
                                playerLinkProps.style = Object.assign({}, Object.assign(Object.assign({}, playerLinkProps.style), { cursor: 'default' }));
                        }
                        else {
                            playerLinkProps.onClick = () => handleClickOpen(individualMatch, teamPlayer, teamIndex, team.teamId, playerIndex);
                        }
                    }
                    else {
                        playerLinkProps.style = Object.assign({}, Object.assign(Object.assign({}, playerLinkProps.style), { cursor: 'default' }));
                    }
                    let playerTableProps = playerLinkProps;
                    playerTableProps.style = Object.assign({}, Object.assign(Object.assign({}, playerLinkProps.style), { padding: 3, width: '100%' }));
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Box, { component: "div", displayPrint: "none", className: "printHide" },
                            React.createElement("table", Object.assign({}, playerTableProps),
                                React.createElement("thead", null),
                                React.createElement("tbody", null,
                                    React.createElement("tr", { style: { borderTop: (playerIndex > 0) ? '1px dashed #aaaaaa' : 'none' } },
                                        React.createElement("td", { style: { border: 0, width: '30%', padding: 4 } }, teamPlayer.playerNumber),
                                        React.createElement("td", { style: { border: 0 } }, teamPlayer.playerName),
                                        React.createElement("td", { style: { border: 0, textAlign: 'right' } },
                                            autoSortPlayers && teamPlayer.points,
                                            team.moveDirectionToBeValid && (team.moveDirectionToBeValid === 'up' ? React.createElement(ArrowUpward, null) : React.createElement(ArrowDownward, null))))))),
                        React.createElement(Box, { display: "none", displayPrint: "block" },
                            React.createElement("table", Object.assign({}, playerTableProps, { style: { padding: 6, width: '100%' } }),
                                React.createElement("thead", null),
                                React.createElement("tbody", null,
                                    React.createElement("tr", { style: { borderTop: (playerIndex > 0) ? '1px dashed #aaaaaa' : 'none' } },
                                        React.createElement("td", { style: { border: 0, width: '30%', padding: props.printBlank ? 10 : 4 } }, !props.printBlank && teamPlayer.playerNumber),
                                        React.createElement("td", { style: { border: 0, padding: props.printBlank ? 10 : 'inherit' } }, !props.printBlank && teamPlayer.playerName),
                                        React.createElement("td", { style: { border: 0, textAlign: 'right', padding: props.printBlank ? 10 : 'inherit' } }, !props.printBlank && autoSortPlayers && teamPlayer.points)))))));
                }))));
            if (individualMatch.isDoubleMatch && team.points) {
                const title = `Samlet point for holdet: ${team.points}`;
                return (React.createElement(Tooltip, { title: title, placement: "right" }, td));
            }
            else if (team.showWarning) {
                return (React.createElement(Tooltip, { title: team.showWarning, placement: "right", onClose: () => { team.showWarning = ''; generateComputedMatchData(); } }, td));
            }
            else {
                return td;
            }
        });
    };
    const buildSetPointCells = (individualMatch) => {
        if (!props.showEditPoints)
            return;
        return React.createElement(React.Fragment, null,
            individualMatch.setPoints.map((set, setIndex) => {
                return (React.createElement(TableCell, { key: individualMatch.matchId + "-" + (setIndex + noOfTeams), className: "points" },
                    React.createElement(Box, { displayPrint: "none", className: "printHide" }, individualMatch.disciplineCode && !(individualMatch.isGoldenSet && setIndex > 0) && React.createElement(EditMatchResultSetPoints, { team1SetPoints: set.points1, team2SetPoints: set.points2, onChange: (team1Points, team2Points) => onSetPointsChange(team1Points, team2Points, individualMatch.matchId, individualMatch.matchIndex, setIndex) })),
                    React.createElement(Box, { display: "none", displayPrint: "block" }, (!props.printBlank && (set.points1 || set.points2)) &&
                        React.createElement("div", null,
                            set.points1,
                            " - ",
                            set.points2))));
            }),
            React.createElement(TableCell, { style: { textAlign: 'center' } },
                individualMatch.disciplineCode &&
                    React.createElement("select", Object.assign({ value: individualMatch.winnerWalkOver || "", title: "Indtast cifrene p\u00E5 det tidspunkt, da kampen blev afbrudt og v\u00E6lg det hold, som har vundet kampen", className: "selectbox printHide" }, extraInputProps, { onChange: (evt) => onSetWalkover(evt.target.value, individualMatch.matchId) }),
                        React.createElement("option", { value: "" }),
                        React.createElement("option", { value: "0", title: individualMatch.teams[0].name }, individualMatch.teams[0].shortName),
                        React.createElement("option", { value: "1", title: individualMatch.teams[1].name }, individualMatch.teams[1].shortName)),
                (individualMatch.disciplineCode && individualMatch.winnerWalkOver === 0 || individualMatch.winnerWalkOver === 1) &&
                    React.createElement(Box, { display: "none", displayPrint: "block" }, !props.printBlank &&
                        React.createElement("div", null, shortTeamName(individualMatch.winnerWalkOver)))));
    };
    const handleGoldenSetDisciplineChange = (individualMatch) => {
        setSelectedPlayer(emptySelectedPlayer);
        individualMatch.teams.map(team => {
            team.players = [];
            team.players.push({ playerName: '', playerNumber: '', points: null, playerGender: '', playerId: null, selectPlayerType: 0 });
            if (individualMatch.disciplineCode.endsWith("D")) {
                team.players.push({ playerName: '', playerNumber: '', points: null, playerGender: '', playerId: null, selectPlayerType: 0 });
            }
        });
        let newMatches = [...individualMatches];
        updateMatches(newMatches);
    };
    const autoSortError = individualMatches.find(match => match.teams.find(team => team.moveDirectionToBeValid !== undefined && team.moveDirectionToBeValid !== ''));
    return (React.createElement("div", null,
        match.matchResultAutosortPlayersEnabled && React.createElement("div", null,
            React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: autoSortPlayers, onChange: handleAutoSortingSwitchChange, name: "autoSortPlayers", size: "small", disabled: true }), label: "Autosortering", className: "printHide" }),
            " ",
            autoSortError && React.createElement(Button, { size: "small", variant: "contained", color: "secondary", endIcon: React.createElement(Reorder, null), onClick: () => autoSort() }, "Sorter kampe i korrekt r\u00E6kkef\u00F8lge")),
        React.createElement(TableContainer, null,
            React.createElement(Table, { "aria-label": "customized table", size: "small", className: classes.playerTable },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, { className: "topRow" },
                        React.createElement(TableCell, null),
                        React.createElement(TableCell, null, match.teamName1),
                        React.createElement(TableCell, null, match.teamName2),
                        setsHeader)),
                React.createElement(TableBody, null,
                    individualMatches.map((individualMatch) => {
                        if (individualMatch.isGoldenSet)
                            return;
                        return (React.createElement(TableRow, { key: individualMatch.matchId },
                            React.createElement(TableCell, { style: { whiteSpace: 'nowrap' } },
                                individualMatch.disciplineRanking,
                                ". ",
                                individualMatch.disciplineCode),
                            buildTeamCells(individualMatch),
                            buildSetPointCells(individualMatch)));
                    }),
                    individualMatches.map((individualMatch) => {
                        if (!individualMatch.isGoldenSet)
                            return;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(TableRow, null,
                                React.createElement(TableCell, { colSpan: 8 },
                                    React.createElement("br", null),
                                    "Golden Set")),
                            React.createElement(TableRow, null,
                                React.createElement(TableCell, null,
                                    React.createElement(FormControl, { className: classes.goldenSetSelect },
                                        React.createElement(Select, { native: true, defaultValue: individualMatch.disciplineCode, id: "grouped-native-select", onChange: (evt) => { individualMatch.disciplineCode = evt.currentTarget.value; handleGoldenSetDisciplineChange(individualMatch); } },
                                            React.createElement("option", { "aria-label": "None", value: "" }),
                                            Object.keys(Disciplines.disciplineCodesMap).map(disciplineKey => {
                                                return React.createElement("option", { value: Disciplines.disciplineCodesMap[disciplineKey] }, Disciplines.disciplineCodesMap[disciplineKey]);
                                            })))),
                                buildTeamCells(individualMatch),
                                buildSetPointCells(individualMatch))));
                    }),
                    autoSortError &&
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 7 }, props.texts.autoSortInfo))))),
        React.createElement(SelectPlayerPopup, { open: open, onClose: handleClose, playersList: selectedTeam, matchData: match, canChoosePlayers: canChoosePlayers, selectedPlayer: selectedPlayerFromChildren, playerReplacementContext: false })));
};
